module.exports = __webpack_public_path__ + "media/small/real_estate_townhomes_sale-small-a9506054.jpeg";